import { GetUser } from "@redotech/account-common/user";
import { useTranslation } from "@redotech/redo-i18n";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import * as selectCss from "@redotech/redo-return-ui/flows/return-flow/select.module.css";
import { AssignState } from "@redotech/redo-return-ui/flows/rules/assign";
import { RuleTypeDetailsProps } from "@redotech/redo-return-ui/flows/rules/multiple-actions";
import { LabeledInput } from "@redotech/redo-web/labeled-input";
import { SelectDropdown } from "@redotech/redo-web/select-dropdown";
import { memo, useContext } from "react";

export const AssignDetails = memo(function AssignDetails({
  state,
  setState,
  disabled,
}: RuleTypeDetailsProps<AssignState>) {
  const { t } = useTranslation();
  const team = useContext(TeamContext);
  const users = (team?.users || []).map((teamUser) => {
    return {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
      id: (teamUser.user as GetUser)._id,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
      name: (teamUser.user as GetUser).name,
    };
  });
  return (
    <LabeledInput label={t("User")}>
      <SelectDropdown
        disabled={disabled}
        options={users}
        value={state.user}
        valueChange={(e) => {
          if (e) {
            setState({ user: e });
          }
        }}
      >
        {(user: { id: string; name: string }) => {
          return (
            <div className={selectCss.value}>
              <div className={selectCss.title}>{user.name}</div>
            </div>
          );
        }}
      </SelectDropdown>
    </LabeledInput>
  );
});
